import { useCart } from 'context/cart/CartContext';
import React, { FC } from 'react';
import CartItem from './cartItem/CartItem';
import styles from './CartPage.module.scss';
import UseCartPage from './UseCartPage';
import { Close, DeleteOutline } from '@material-ui/icons';
import { moneyMaskNumber } from 'utils/mask/money';
import { useI18n } from 'utils/i18n/hooks/useI18n';

export interface ICartViewProps {
    onClickClose?: () => void
}

const CartPage: FC<ICartViewProps> = ({ onClickClose }) => {
    const { cartItems, clearCart, totals } = useCart();
    const { sendPreOrder, stockResult, isCheckingStock } = UseCartPage();
    const { t } = useI18n();

    const isConfirmDisabled = isCheckingStock || (stockResult !== null && !stockResult.allAvailable);

    return (
        <div id={styles.CartView}>
            <div className={styles.container}>
                <header>
                    <h1>{t("cart.title")}</h1>
                    <button onClick={onClickClose}>
                        <Close />
                    </button>
                </header>
                <div className={styles.content} >
                    <div className={styles.clearCartContainer}>
                        <button onClick={clearCart}>
                            <DeleteOutline />
                            <p>{t("cart.clear")}</p>
                        </button>
                    </div>
                    {cartItems.map((cartItem) => {
                        const stockProduct = stockResult?.products.find(p => p.productId === cartItem.productId);
                        return (
                            <CartItem
                                key={cartItem.id}
                                cartItem={cartItem}
                                stockProduct={stockProduct}
                            />
                        );
                    })}
                </div>
                <footer>
                    <span>{t("cart.total")} {moneyMaskNumber(totals.totalPrice)}</span>
                    <button
                        onClick={sendPreOrder}
                        className={styles.submitButton}
                        disabled={isConfirmDisabled}
                    >
                        {t("cart.confirm")}
                    </button>

                    <button onClick={onClickClose} className={styles.backButton}>
                        {t("cart.continueShopping")}
                    </button>
                </footer>
            </div>
        </div>
    )
}
export default CartPage